import { useState } from 'react';
import { useUploadMediaMutation } from '@apps/graphql/api';

const ContactForm = ({onSubmit}) => {
  const INITIAL_STATE = {
    name: "",
    email: "",
    phone: "",
    cv: "",
    portfolio: "",
    message: "",
    media: null,
  };
  const [contact, setContact] = useState(INITIAL_STATE);

  const clearFileInput = () => {
    const fileInput = document.getElementById('cv');
    fileInput.value = '';
    setContact((prevState) => ({ ...prevState, cv: '' }));
  }

  const [uploadMediaMutation] = useUploadMediaMutation({
    onCompleted: (data) => {
      setContact((prevState) => ({ ...prevState, media: data?.id }))
      onSubmit(contact)
      resetForm()
    },
    onError: (error) => {
      console.log(error)
    }
  })

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setContact((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    await uploadMediaMutation({
      variables: {
        file: contact?.cv
      }
    })
  };

  const resetForm = () => {
    setContact(INITIAL_STATE);
    clearFileInput()
  }

  return (
    <div className="container">
      <form id='contact-form' method='post' onSubmit={handleSubmit}>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-7'>
          <div>
            <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
              Name<span className='text-red'>*</span>
            </label>
            <input
              name='name'
              className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
              id='name'
              type='text'
              placeholder="Name"
              value={contact.name}
              onChange={handleChange}

              required
            />
          </div>
          <div>
            <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
              Email<span className='text-red'>*</span>
            </label>
            <input
              name='email'
              className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
              id='email'
              type='email'
              placeholder="Email"
              value={contact.email}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
              Phone Number<span className='text-red'>*</span>
            </label>
            <input
              name='phone'
              className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
              id='phone'
              type='tel'
              pattern="^\d{10,12}$"
              placeholder="Phone Number"
              value={contact.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div class="relative">
            <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
              Upload CV
            </label>
            <input
              name='cv'
              className='contact-form-input border-jacarta-100 hover:ring-accent/10 border focus:ring-accent focus:border-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg p-2 hover:ring-1 dark:text-white'
              id='cv'
              type='file'
              placeholder="Upload CV"
              onChange={(e) => {
                setContact((prevState) => ({ ...prevState, cv: e.target.files[0] }))
              }}
            />
            {contact.cv && contact.cv !== '' && (
              <button
                type="button"
                className="remove-button"
                onClick={() => clearFileInput()}
              >
                &#x2716;
              </button>
            )}
          </div>
          <div>
            <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
              Portfolio Link
            </label>
            <input
              name='portfolio'
              className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
              id='portfolio'
              type='text'
              placeholder="Portfolio Link"
              value={contact.portfolio}
              onChange={handleChange}
            />
          </div>
          <div className='mb-4 md:col-span-2'>
            <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
              Message<span className='text-red'>*</span>
            </label>
            <textarea
              id='message'
              className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
              required
              name='message'
              placeholder="Write your message..."
              value={contact.message}
              onChange={handleChange}
              rows='5'
            />
          </div>
        </div>

        <button
          type='submit'
          className='bg-primary hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all'
          id='contact-form-submit'
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
